import gql from 'graphql-tag';
import deviceFragment from '../fragments/device';
import placeFragment from '../fragments/place';

const CREATE_DEVICE = gql`
  mutation createDevice($data: CreateDeviceInput!) {
    createDevice(data: $data) {
      ...deviceDetails
      devicePlaces {
        placeId
        place {
          ...placeDetails
        }
      }
      modelId
      placeOpened
    }
  }
  ${deviceFragment.FRAGMENT_DEVICE}
  ${placeFragment.FRAGMENT_PLACE}
`;

const DELETE_DEVICE_BY_ID = gql`
  mutation deleteDeviceById($id: ID!) {
    deleteDeviceById(id: $id) {
      id
      name
    }
  }
`;

const UPDATE_DEVICE_BY_ID = gql`
  mutation updateDeviceById($id: ID!, $data: UpdateDeviceInput) {
    updateDeviceById(id: $id, data: $data) {
      ...deviceDetails
    }
  }
  ${deviceFragment.FRAGMENT_DEVICE}
`;

const SET_DEVICE_PLACE_OPENED = gql`
  mutation SetDevicePlaceOpened($deviceId: ID!) {
    setDevicePlaceOpened(id: $deviceId) {
      id
      placeOpened
    }
  }
`;

export default {
  CREATE_DEVICE,
  UPDATE_DEVICE_BY_ID,
  DELETE_DEVICE_BY_ID,
  SET_DEVICE_PLACE_OPENED,
};
